import React, { Component } from "react";

class TermsContent extends Component {
  render() {
    return (
      <section className="section testimonial-area ptb_100">
        <div className="container text-center">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-10 col-lg-8">
              <h2 className="mt-4 mb-3">Terms & Conditions</h2>
              {/* <p className="mb-3">Last Updated on December 29, 2025</p> */}
              <div className="col-12 col-md-12 row">
                <div style={{ textAlign: "start" }}>
                  These terms and conditions (“Terms & Conditions”) govern your
                  use of the website –{" "}
                  <a href="https://moneymonkapp.in/" target="_blank">
                    https://moneymonkapp.in/
                  </a>{" "}
                  ("Website") and mobile application –{" "}
                  <a
                    href="https://play.google.com/store/apps/details?id=com.monkCapital.moneyMonk"
                    target="_blank"
                  >
                    MoneyMonk
                  </a>{" "}
                  ("App") (Website and/or App shall collectively be referred to
                  as “Platform”) owned and operated by Monk Capital Private
                  Limited, an RBI-registered NBFC (Reg. No. N-09.00457). with
                  its registered office at The Platina, B-406, Jayabheri
                  Enclave, Gachibowli, Hyderabad, Telangana - 500032, India
                  (hereinafter referred to as “Us” / “We” / “Monk Capital
                  Private Limited” / “MCPL”).
                  <br />
                  <br />
                  As a user ("User" or "You") of the Platform, You understand
                  that MoneyMonk is a digital lending platform providing loans
                  (Serviced by Monk Capital Private Limited and other NBFC
                  partners). MoneyMonk platform provides access between multiple
                  Users in the form of consumers, financial institutions, data
                  partners and other partner lenders, service providers etc.
                  with a view to facilitate lending and borrowing activities.{" "}
                  <br />
                  <br />
                  Please read these Terms & Conditions carefully before
                  accessing or using our Platform or any part thereof. By
                  accessing or using any part of the Platform, You agree to be
                  bound by these Terms & Conditions. If You do not agree to all
                  the terms and conditions, then YOU MAY NOT ACCESS THE PLATFORM
                  OR USE ANY SERVICES PROVIDED BY US.
                  <br />
                  <br />
                  These Terms and Conditions form a legal and binding agreement
                  between the User and Us and is made pursuant to the terms of
                  the Information Technology Act, 2000.
                </div>
                <h3 className="mt-4 mb-2">1. GENERAL</h3>
                <p style={{ textAlign: "start" }}>
                  The Platform/App provides access to an online technology
                  platform bringing together consumers, financial institutions,
                  data partners and other partners. Monk Capital Private Limited
                  is an NBFC - Investment and Credit Company registered with the
                  Reserve Bank of India and holds license to engage in
                  activities relating to lending and investment. Monk Capital
                  Private Limited is not a deposit taking company or a chit fund
                  or a company offering any investment schemes as per the rules
                  and regulations for the time being in force in India.
                  <br />
                  <br />
                  MoneyMonk is a digital platform that acts as an access between
                  Monk Capital Private Limited and users in need of borrowings.
                  The final decision as regards lending and borrowing is subject
                  to the choice of the respective Users in their respective
                  capacities as borrower or the NBFC https://www.monkcapital.in/
                  the MoneyMonk platform.
                  <br />
                  <br />
                  In the event You wish to avail any of the products displayed
                  on the Platform, You will be required to provide certain
                  information.
                  <ul style={{ padding: 20 }}>
                    <li className="mb-2">
                      • Facilitating provision of small term loans to Users
                      through its NBFC -Monk Capital Private Limited.
                    </li>
                    <li className="mb-2">
                      • Assisting its Users to obtain their credit report
                      through authorized agents partnered with Monk Capital
                      Private Limited. Monk Capital Private Limited will monitor
                      and update the credit report obtained by the customer
                      through the use of the Platform as and when it receives
                      such report from the authorized agents.
                    </li>
                    <li className="mb-2">
                      • Provision support to the Users in verifying the
                      financial capabilities of Users.
                    </li>
                  </ul>
                  For the provision of the above-mentioned Services, MoneyMonk
                  will be using and sharing the information of the User with
                  multiple financial institutions and other parties, as may be
                  required for the purpose mentioned above and MoneyMonk shall
                  also run multiple credit checks to be able to get the best
                  available offers to suit the needs of the Users.
                </p>
                <h3 className="mt-4 mb-2"> Do Not Disturb</h3>
                <p style={{ textAlign: "start" }}>
                  In the event You have registered Your phone number on the ‘Do
                  Not Disturb’ registers with Your network provider, You shall
                  ensure to take all steps to enable the Company’s
                  representative’s to contact You via phone to provide details
                  about different financial products and You shall ensure that
                  such calls received by You are pursuant to You providing Us
                  with information and You shall not register a compliant with
                  the relevant authorities for the same.
                </p>
                <h3 className="mt-4 mb-2">2. ELIGIBILITY</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  The User of this Website unequivocally declares and agrees
                  that in case of an individual, the User is a natural / legal
                  person who has attained the age of at least 21 years(Twenty
                  One Years) and is legally allowed to enter into a contract in
                  India. The User is allowed to utilize the Services in
                  accordance with these Terms & Conditions. If the User violates
                  any of these Terms & Conditions, or otherwise violates an
                  agreement entered into through the medium of the Website /
                  App, MoneyMonk may terminate the User’s membership, delete
                  his/her profile and any content or information posted online
                  by the User on the Platform or prohibit the User from using or
                  accessing the Platform at any time in its sole discretion,
                  with or without notice, including without limitation if
                  MoneyMonk believes that User is under the age of 21 (Twenty
                  One) years.
                </p>
                <h3 className="mt-4 mb-2">
                  3. ACCEPTANCE OF TERMS AND CONDITIONS
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  As a User of this Platform, You have agreed to the Terms &
                  Conditions provided hereunder or anywhere else on this
                  Platform including but not limited to disclaimers on this
                  Platform.
                  <br />
                  <br />
                  We reserve the right, at its sole discretion, to change,
                  modify, add or remove portions of these Terms & Conditions, at
                  any time without any prior written notice to the User. It is
                  the User’s responsibility to review these Terms & Conditions
                  periodically for any updates/ changes. User’s continued use of
                  the App or Website following the modification of these Terms
                  and Conditions will imply the acceptance by the User of the
                  revisions.
                </p>
                <h3 className="mt-4 mb-2">4. YOUR ACCOUNT</h3>
                <p style={{ textAlign: "start" }}>
                  If You wish to use the Platform, You are required to maintain
                  an account on the Website or App and will be required to
                  furnish certain information and details, including Your name,
                  email id, contact number and any other information deemed
                  necessary by Monk Capital Private Limited for the purpose of
                  accepting your eligibility for the financial products offered
                  on our Platform through our digital lending
                  application-MoneyMonk.
                  <br />
                  <br /> You are responsible for maintaining the confidentiality
                  and security of Your account, password/OTP, activities that
                  occur in or through Your account and for restricting access to
                  Your computer/mobile to prevent unauthorized access to Your
                  account. You agree to accept responsibility for all activities
                  that occur under Your account or password/OTP. You should take
                  all necessary steps to ensure that the password/OTP is kept
                  confidential and secure and should inform us immediately if
                  You have any reason to believe that Your password/OTP has
                  become known to anyone else, or if the password/OTP is being,
                  or is likely to be, used in an unauthorized manner. Please
                  ensure that the details You provide Us with are true, correct,
                  accurate and complete. Upon MoneyMonk gaining knowledge or
                  having any reasonable suspicion that the information provided
                  by you is wrong, inaccurate or incorrect, MoneyMonk shall
                  immediately terminate your account without any notice to You
                  in this regard. In the event of any changes to the information
                  shared by You at the time of registering Yourself on the
                  Platform, You shall be responsible for forthwith notifying the
                  said changes to us.
                  <br />
                  <br />
                  You may update your mobile number only if it is linked with
                  your Aadhaar. This process requires OTP verification of your
                  Aadhaar number through UIDAI. It is your responsibility to
                  ensure that the Aadhaar-linked mobile number is active and
                  accessible. By initiating the update, you consent to
                  Aadhaar-based verification for this purpose.
                </p>
                <h3 className="mt-4 mb-2">5. PRIVACY</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  MoneyMonk collects certain information from You in order to
                  provide the Services. MoneyMonk’s use of Your personal
                  information is governed in accordance with the Privacy Policy
                  located at <a href="">moneymonkapp.in/privacy-policy</a>.
                </p>
                <h3 className="mt-4 mb-2">6. LICENSE AND ACCESS</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  MoneyMonk grants you a limited, non-transferable and revocable
                  license to access and use the Platform or any part thereof for
                  availing the Services, but not to download any material from
                  it (other than page caching) or modify it, or any portion of
                  it, except with express consent of MoneyMonk and / or its
                  affiliates, as may be applicable. Any unauthorized access to
                  the Platform (or any part thereof) or any networks, servers or
                  computer systems connected to Platform and any attempt to
                  modify, adapt, translate or reverse engineer any part of the
                  Platform or re-format or frame any portion of the pages of the
                  Platform, save to the extent expressly permitted by these
                  Terms & Conditions, is not permitted.
                  <br />
                  <br />
                  This license is non-transferable and does not permit any
                  resale or commercial use of this Platform or its contents; any
                  downloading or copying of account information for the benefit
                  of anyone other than Your use; or any use of data mining,
                  robots, or similar data gathering and extraction tools. The
                  Platform or any portion of the Platform (including but not
                  limited to any copyrighted material, trademarks, or other
                  proprietary information) may not be reproduced, duplicated,
                  copied, sold, resold, visited, distributed or otherwise
                  exploited for any commercial purpose without express written
                  consent of MoneyMonk and/or Monk Capital Private Limited and /
                  or its affiliates, as may be applicable. Any unauthorized use
                  of the Platform shall terminate the permission or revoke the
                  license granted by MoneyMonk and/or Monk Capital Private
                  Limited.
                </p>
                <h3 className="mt-4 mb-2">
                  7. MONITORING OF THE PLATFORM AND YOUR ACCOUNT
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  Monk Capital Private Limited always has the right and liberty
                  to monitor the content of the Platform or any part thereof
                  which shall include information provided in Your account. The
                  monitoring of the Platform is important to determine the
                  veracity of the information provided by You and that every
                  User remains in consonance with the Terms & Conditions
                  provided herein. Subject to the Terms & Conditions mentioned
                  herein, Monk Capital Private Limited shall also have the
                  liberty to remove any objectionable content which is in
                  contravention of the Terms & Conditions or any applicable laws
                  in force in India or share such information with any
                  governmental authority as per procedures laid down by the law
                  for the time being in force in India.
                </p>
                <h3 className="mt-4 mb-2">8. SERVICE SUSPENSION</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  MoneyMonk may wish to stop providing the Services and may
                  terminate use of it at any time without giving notice of
                  termination to You. Unless MoneyMonk informs the User
                  otherwise, upon any termination, (a) the rights and licenses
                  granted to You in these Terms and Conditions will end and (b)
                  User must stop using the Platform or any part thereof
                  forthwith. MoneyMonk reserves the right to suspend or cease
                  providing any Service and shall have no liability or
                  responsibility to the User in any manner whatsoever.
                </p>
                <h3 className="mt-4 mb-2">9. PROHIBITED USES</h3>
                <p style={{ textAlign: "start" }}>
                  In addition to other prohibitions as set forth in the Terms &
                  Conditions, You are prohibited from using the Platform:
                  <ol
                    style={{
                      padding: 20,
                    }}
                  >
                    <li className="mb-2">
                      I. To submit false, misleading, forged, or counterfeit
                      information, including falsified KYC or financial details.
                    </li>
                    <li className="mb-2">
                      II. To intentionally default on, delay, or avoid repayment
                      obligations under any loan or facility availed through the
                      Platform.
                    </li>
                    <li className="mb-2">
                      <li className="mb-2">
                        III. To intentionally default on, delay, or avoid
                        repayment obligations under any loan or facility availed
                        through the Platform.
                      </li>
                    </li>
                    <li className="mb-2">
                      IV. To engage in money laundering, terrorist financing,
                      gambling, betting, or other prohibited financial
                      activities.
                    </li>
                    <li className="mb-2">
                      V. To create multiple accounts, impersonate another person
                      or entity, or otherwise misrepresent your identity.
                    </li>
                    <li className="mb-2">
                      VI. To infringe upon or violate our intellectual property
                      rights or the intellectual property rights of others.
                    </li>
                    <li className="mb-2">
                      VII. To reverse engineer, decompile, disassemble, tamper
                      with, or otherwise attempt to interfere with the
                      Platform’s code, algorithms, or security features.
                    </li>
                    <li className="mb-2">
                      <li className="mb-2">
                        VIII. To reverse engineer, decompile, disassemble,
                        tamper with, or otherwise attempt to interfere with the
                        Platform’s code, algorithms, or security features.
                      </li>
                    </li>
                    <li className="mb-2">
                      IX. To upload or transmit viruses, malware, or any other
                      malicious code that could affect the functionality,
                      security, or operation of the Platform, related websites,
                      or the Internet.
                    </li>
                    <li className="mb-2">
                      X. To spam, phish, pharm, pretext, spider, crawl, or use
                      automated systems (including bots or scripts) to access or
                      misuse the Platform.
                    </li>
                    <li className="mb-2">
                      XI. To collect, scrape, harvest, or track the personal
                      information of others without consent.
                    </li>
                    <li className="mb-2">
                      XII. To harass, abuse, insult, harm, defame, slander,
                      disparage, intimidate, or discriminate based on gender,
                      sexual orientation, religion, ethnicity, race, caste, age,
                      national origin, or disability.
                    </li>
                    <li className="mb-2">
                      XIII. For any unlawful, illegal, fraudulent, or prohibited
                      purpose.
                    </li>
                    <li className="mb-2">
                      XI. To collect, scrape, harvest, or track the personal
                      information of others without consent.
                    </li>
                    <li className="mb-2">
                      XV. To violate any applicable international, federal,
                      state, provincial, or local laws, rules, or regulations.
                    </li>
                    <li className="mb-2">
                      XVI. To engage in obscene, immoral, pornographic, or
                      otherwise inappropriate activities.
                    </li>
                    <li className="mb-2">
                      XVII. To interfere with or circumvent the security
                      features of the Platform, related websites, other
                      websites, or the Internet.
                    </li>
                  </ol>
                  For the provision of the above-mentioned Services, MoneyMonk
                  will be using and sharing the information of the User with
                  multiple financial institutions and other parties, as may be
                  required for the purpose mentioned above and MoneyMonk shall
                  also run multiple credit checks to be able to get the best
                  available offers to suit the needs of the Users.
                </p>
                <h3 className="mt-4 mb-2">
                  10. LIMITATION OF LIABILITY AND DISCLAIMER OF WARRANTIES
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  Notwithstanding anything to the contrary contained herein,
                  neither Monk Capital Private Limited nor its affiliated
                  companies, subsidiaries, officers, directors, employees,
                  partners or any related party shall have any liability to You
                  or to any third party for any indirect, incidental, special or
                  consequential damages or any loss of revenue or profits
                  arising under or relating to these Terms & Conditions. To the
                  maximum extent permitted by law, You waive, release, discharge
                  and hold harmless Monk Capital Private Limited, its affiliated
                  and subsidiary companies, and each of their directors,
                  officers, employees, partners, and agents, from any and all
                  claims, losses, damages, liabilities, expenses and causes of
                  action arising out of Your use of the Platform / Website /
                  App.
                  <br />
                  <br />
                  As a User, You also acknowledge that MoneyMonk has maintained
                  and carried out all possible checks and balances to assure the
                  credibility of the Users as listed on the Platform. The
                  information provided on the Website / App is based on the
                  information that is provided to MoneyMonk by its Users. In
                  case the User does not disclose any information to MoneyMonk,
                  and the same is not found out at the first instance by
                  MoneyMonk, MoneyMonk shall not be responsible for any claims
                  or liabilities.
                  <br />
                  <br />
                  MoneyMonk in any event is not responsible for any default in
                  return of money that is borrowed from the financial partners
                  and the financial partners shall have the exclusive right to
                  initiate proceedings against the defaulter borrower. MoneyMonk
                  shall to the best of its abilities aid the concerned User in
                  terms of provision of information to initiate any legal
                  proceedings. However, MoneyMonk shall not be responsible for
                  any default on behalf of the User.
                  <br />
                  <br />
                  MoneyMonk is merely a digital lending platform and the User is
                  entitled to conduct its own diligence before taking any steps
                  to initiate the processes outlined on the Platform.
                </p>
                <h3 className="mt-4 mb-2">11. INDEMNITY</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  You agree to indemnify, save, and hold Monk Capital Private
                  Limited, its affiliates, contractors, employees, officers,
                  directors, agents and its third party associates, licensors,
                  and partners harmless from any and all claims, demands,
                  losses, damages, and liabilities, costs and expenses,
                  including without limitation legal fees and expenses, arising
                  out of or related to Your use or misuse of the Services or of
                  the Website or App or Platform, any violation by You of these
                  Terms & Conditions, or any breach of the representations,
                  warranties, and covenants made by You herein or Your
                  infringement of any intellectual property or other right of
                  any person or entity, or as a result of any threatening,
                  libelous, obscene, harassing or offensive material posted/
                  transmitted by You on the Website / App. MoneyMonk reserves
                  the right, at Your expense, to assume the exclusive defense
                  and control of any matter for which You are required to
                  indemnify MoneyMonk, including rights to settle, and You agree
                  to cooperate with MoneyMonks’ defense and settlement of these
                  claims. MoneyMonk will use reasonable efforts to notify you of
                  any claim, action, or proceeding brought by a third party that
                  is subject to the foregoing indemnification upon becoming
                  aware of it. This paragraph shall survive termination of this
                  Terms & Conditions.
                </p>
                <h3 className="mt-4 mb-2">
                  12. ADVERTISERS/ THIRD PARTY LINKS ON THE PLATFORM
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  Monk Capital Private Limited accepts no responsibility for
                  advertisements contained within the Platform or any part
                  thereof. Monk Capital Private Limited has no control over and
                  accepts no responsibility for the content of any website or
                  mobile application to which a link from the Platform or any
                  part thereof exists. Such linked websites and mobile
                  applications are provided “as is” for User’s convenience only
                  with no warranty, express or implied, for the information
                  provided within them or the veracity thereof.
                </p>
                <h3 className="mt-4 mb-2">
                  13. USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  If, at MoneyMonk’s request, you send certain specific
                  submissions (for example contest entries) or without a request
                  from us, you send creative ideas, suggestions, proposals,
                  plans, or other materials, whether online, by email, by postal
                  mail, or otherwise (collectively, 'comments'), You agree that
                  We may, at any time, without restriction, edit, copy, publish,
                  distribute, translate and otherwise use in any medium any
                  comments that You forward to Us. We are and shall be under no
                  obligation (a) to maintain any comments in confidence; (b) to
                  pay compensation for any comments or (c) to respond to any
                  comments
                  <br />
                  <br />
                  You agree that your comments will not violate any right of any
                  third-party, including copyright, trademark, privacy,
                  personality or other personal or proprietary right. You
                  further agree that Your comments will not contain libelous or
                  otherwise unlawful, abusive or obscene material, or contain
                  any computer virus or other malware that could in any way
                  affect the operation of the Service or any related website.
                  You may not use a false e-mail address, pretend to be someone
                  other than Yourself, or otherwise mislead us or third-parties
                  as to the origin of any comments. You are solely responsible
                  for any comments You make and their accuracy. We take no
                  responsibility and assume no liability for any comments posted
                  by You or any third-party.
                  <br />
                  <br />
                  You are licensing to MoneyMonk and/or Monk Capital Private
                  Limited and its service providers, any information, data,
                  passwords, materials or other content (collectively,
                  “Content”) You provide through or to the Service. Company and
                  service provider of Company may use, modify, display,
                  distribute and create new material using such Content to
                  provide the Service to You. We may also use, sell, license,
                  reproduce, distribute and disclose aggregate, non-personally
                  identifiable information that is derived through Your use of
                  the Service. By submitting Content, You automatically agree,
                  or promise that the owner of such Content has expressly agreed
                  that, without any particular time limit, and without the
                  payment of any fees, Monk Capital Private limited is the
                  company that disburses loan and may use the Content for the
                  purposes set out above. As between Monk Capital Private
                  Limited and third-party service provider, Company owns Your
                  confidential account information.
                </p>
                <h3 className="mt-4 mb-2">14. ACKNOWLEDGEMENTS</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  You acknowledge that MoneyMonk is a platform bringing Users
                  together and that the MoneyMonk is not engaged in either grant
                  of loan or borrowing any money or assistance for any financial
                  products from any member using the MoneyMonk Platform. You
                  acknowledge that the use of the financial products is entirely
                  based on the negotiations between the Users and third party
                  and neither MoneyMonk nor its affiliates, contractors,
                  employees, officers, directors, agents and their third-party
                  associates, licensors and partners have any interest with
                  regard to any financial products assistance procured by or to
                  a registered User. You acknowledge that MoneyMonk will not be
                  responsible for any claim or damage in case of use of the
                  financial products. MoneyMonk in no manner warrants or
                  guarantees the performance of a third-party service provider
                  that is providing services through the App. You acknowledge
                  that MoneyMonk in no manner guarantees that the Users have
                  provided all the information on this App which is true and
                  correct including his address, phone numbers etc. You
                  acknowledge that it is Your responsibility to verify the
                  information about the person on the Platform and MoneyMonk is
                  in no manner liable if the information provided on this App is
                  untrue or incorrect. You acknowledge that MoneyMonk is in no
                  manner responsible for any claim of money or damages in the
                  event one person fails to either grant loan or a person fails
                  to repay the loan or misrepresents his financial status or
                  commits a fraud or cheating or any other such illegal act.
                </p>
                <h3 className="mt-4 mb-2">
                  15. CONSUMER CONSENT (For Experian)
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  I do hereby give my free consent and authorize Monk Capital
                  Private Limited by providing my personal information to obtain
                  my Credit Information Report and Credit Score from Experian
                  from time to time for the purpose of lending and onboarding me
                  onto the "MoneyMonk" app, a digital lending platform and not
                  for any other purpose. I hereby unconditionally consent to and
                  instruct Experian to provide my Credit Information to Monk
                  Capital Private Limited. I also acknowledge that I shall not
                  raise any claim or hold liable Experian in relation to my
                  Credit Information Report and Credit Score provided or to be
                  provided by Experian to Monk Capital Private Limited. I
                  understand that I shall have the option to opt out/unsubscribe
                  from the service.
                </p>
                <h3 className="mt-4 mb-2">
                  16. CONSUMER CONSENT (For TransUnion)
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  I do hereby give my free consent and authorize Monk Capital
                  Private Limited by providing my personal information to obtain
                  my Credit Information Report and Credit Score from TransUnion
                  from time to time for the purpose of lending and onboarding me
                  onto the "MoneyMonk" app, a digital lending platform and not
                  for any other purpose. I hereby unconditionally consent to and
                  instruct TransUnion to provide my Credit Information to Monk
                  Capital Private Limited. I also acknowledge that I shall not
                  raise any claim or hold liable TransUnion in relation to my
                  Credit Information Report and Credit Score provided or to be
                  provided by TransUnion to Monk Capital Private Limited. I
                  understand that I shall have the option to opt out/unsubscribe
                  from the service.
                </p>
                <h3 className="mt-4 mb-2">17. APPLICABLE LAWS</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  Your use of this Platform and any Term & Conditions stated in
                  this agreement is subject to laws of India. In case of any
                  disputes arising out of the use of the Platform or any part
                  thereof, Courts of Hyderabad, India will have exclusive
                  jurisdiction.
                </p>
                <h3 className="mt-4 mb-2">18. REFUNDS & CANCELLATION</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  Borrowers are entitled to a cooling-off period of 1 (One) day
                  from the date of loan disbursement, during which they may
                  cancel the loan by repaying the principal and applicable
                  interest without penalty. Retained Processing Fee (INR) shall
                  be applicable in case of Loan Closure during the cooling-off
                  period. After this period, cancellations are not permitted.
                  <br />
                  <br />
                  Any additional payment made by you shall be refunded within 30
                  (thirty) days pursuant to reconciliation of the accounts by
                  MoneyMonk.
                </p>
                <h3 className="mt-4 mb-2">19. CONTACT US</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  Please feel free to reach out to us for any complaint/
                  feedback at
                  <img
                    src="/img/phone-light.png"
                    alt="PHONE"
                    style={{ height: "35px" }}
                  />
                  or email us at Support{" "}
                  <img
                    src="/img/mail-light.png"
                    alt="EMAIL"
                    style={{ height: "15px" }}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default TermsContent;
